import * as form from '../form';

export const historyFederal = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Branch: form.branch(xitem.Branch), // PVQ only
        Dates: form.daterange(xitem.Dates), // Used in SF8X and PVQ
        Name: form.text(xitem.Name), // Used in SF8X and PVQ
        Position: form.text(xitem.Position),
        Address: form.location(xitem.Address),
        Comments: form.textarea(xitem.Comments),
        ReasonLeft: form.textarea(xitem.ReasonLeft), // PVQ Only
        Reprimand: form.collection( // PVQ Only
          ((xitem.Reprimand || {}).items || []).map((y) => {
            const yitem = y.Item || {};
            return {
              Item: {
                DisciplinaryAction: form.radio(yitem.DisciplinaryAction),
                DisciplinaryActionOtherExplaination: form.text(yitem.DisciplinaryActionOtherExplaination),
                Date: form.datecontrol(yitem.Date),
                GivenBy: form.name(yitem.GivenBy),
                GivenByNotApplicable: form.notapplicable(yitem.GivenByNotApplicable),
                GivenByTelephone: form.collection(form.telephoneCollection(yitem.GivenByTelephone || {})),
                GivenByEmail: form.collection(form.emailCollection(yitem.GivenByEmail || {})),
                Has: form.branch(yitem.Has),
                Text: form.textarea(yitem.Text),
              },
            };
          })
        ),
      },
    };
  });
  return {
    HasFederalService: form.branch(data.HasFederalService), // Used in SF8X and PVQ
    Comments: form.textarea(data.Comments),
    SummaryComments: form.textarea(data.SummaryComments),
    List: form.collection(items, (data.List || {}).branch),
  };
};
